var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"buttons"},[_c('p',[(_vm.navLinkTo)?_c('app-content-nav-link',{staticClass:"btn btn_back btn_seznam",attrs:{"link":_vm.navLinkTo,"text":_vm.navLinkTitle}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }